<template>
  <ve-histogram :data="chartData" :settings="chartSettings" :extend="extend" :events='chartEvents' ></ve-histogram>
</template>

<script>
let self;
  export default {
    props:{
      chartSettings:Object,
      chartData:Object,
      height:String,
      width:String,
      extend:Object

  },
     mounted() {
      self=this
    },
    data () {
       this.chartEvents = {
        click: function (e) {
          self.$emit('click',{value:e})
        }
      }
      return {
       
    }
  }
  }
</script>


// WEBPACK FOOTER //
// src/components/chart/Histogram.vue